<div class="mic-error h-full">
  <div class="mic-error-container flex flex-row">
    @if (isUnauthorized) {
      <div class="mic-error-panel flex flex-col justify-around">
        <div class="oops">OOPS...!</div>
        <div>
          <div class="error-code">401</div>
          <div class="error">No está autorizado para acceder a la aplicación. No es un empleado MEPSA.</div>
        </div>
        <div>
          <div class="help">Intente volver a conectarse :</div>
          <div class="links">
              <a href="">LOGIN</a>
          </div>
        </div>
      </div>
    } @else {
      <div class="mic-error-panel flex flex-col justify-around">
        <div class="oops">¡Hasta la próxima!</div>
        <div>
          <div class="error">Se ha cerrado correctamente la sesión.</div>
        </div>
        <div>
          <div class="help">Si desea volver a conectarse :</div>
          <div class="links">
            <a href="">LOGIN</a>
          </div>
        </div>
      </div>
    }
  </div>
</div>